import { useQuery } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export function usePendingApprovals(orgId) {
    return useQuery({
        queryKey: ['pending-approvals', orgId],
        queryFn: () => apiHelper.getResource('/hr/pending-approvals/', { orgId }),
        enabled: !!orgId,
        staleTime: 30000,
        retry: false,
    });
}
